<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="w-full">
      <div slot="no-body" class="tabs-container pt-6" id="view-customer-tab">
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="hardwareMappingList"
            :description="false"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("system.label.ProvisioningDevice") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push('/createDevice').catch(() => {})"
                  size="small"
                  >{{ $t("system.label.CreateDevice") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("system.label.ItemClass") }}</vs-th>
              <vs-th>{{ $t("system.label.ProvisioningSystem") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("system.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="hardwareMappingList"
                v-for="(hardwareMappingList, index) in data"
              >
                <vs-td :data="hardwareMappingList.itemClassName">{{
                  hardwareMappingList.itemClassName
                }}</vs-td>
                <vs-td :data="hardwareMappingList.provisioningValue">{{
                  hardwareMappingList.provisioningValue
                }}</vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('system.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editCreateDevice(hardwareMappingList.id)"
                      class="icon_row"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      deleteProvisioningPopup: false,
      delId: 0,
    };
  },
  components: {
    AtomSpinner,
  },
  computed: {
    ...mapGetters({
      hardwareMappingList: "provisioningConfig/gethardwaresList",
    }),
  },
  methods: {
    async getDeviceData() {
      this.loading = true;
      try {
        await this.$store.dispatch("provisioningConfig/sethardwaremappingData");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    editCreateDevice(id) {
      this.$router.push(`/editCreateDevice/${id}`);
    },
  },
  mounted() {
    this.getDeviceData();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
</style>
